export enum ToolsKey {
  ONTARIO_PROBATE_CALCULATOR = 'ontario-probate-calculator',
  CALIFORNIA_PROBATE_FEE_CALCULATOR = 'california-probate-fee-calculator',
  CALIFORNIA_PROBATE_BOND_CALCULATOR = 'california-probate-bond-calculator',
  BC_PROBATE_FEE_CALCULATOR = 'bc-probate-fee-calculator',
  ESTATE_PLAN_DIAGNOSTIC = 'estate-plan-diagnostic',
  FINAL_TAXES_CALCULATOR = 'final-taxes-calculator',
  ESTATE_LIGHT_DIAGNOSTIC = 'estate-light-diagnostic'
}
